"use client";

import { usePathname } from "next/navigation";
import NavBar from "@/components/layout/NavBar";
import { Footer } from "@/components/layout/Footer";

const HIDE_NAV_PREFIXES = [
  "/forgot-password",
  "/verify-email",
];

export default function NavBarGuard({ children }: { children: React.ReactNode }) {
  const pathname = usePathname() || "";

  const hideNav = HIDE_NAV_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));

  // The footer is required on every page (MWBI-901), including the two routes
  // that hide the rest of the chrome. No sticky-footer wrapper here: both of
  // those pages already set min-h-screen on their own root, so the band lands
  // below a full screen without a second height wrapper fighting them.
  if (hideNav) {
    return (
      <>
        {children}
        <Footer />
      </>
    );
  }

  return <NavBar>{children}</NavBar>;
}
